import { Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppBar } from "../../../shared/ui/AppBar";

const ProminentAppBar = styled(AppBar)(({ theme }) => ({
    // Navigation-specific positioning logic
    zIndex: theme.zIndex.drawer + 1, // Above drawer specifically
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.short,
    }),
}));

interface NavHeaderProps {
    children: React.ReactNode;
}

/**
 * NavHeader
 *
 * App bar wrapper for navigation headers. Renders children inside a prominent, fixed-position app bar above the drawer.
 *
 * @param children - Content to render inside the navigation header toolbar
 */
export const NavHeader = ({ children }: NavHeaderProps) => {
    return (
        <ProminentAppBar position="fixed">
            <Toolbar>{children}</Toolbar>
        </ProminentAppBar>
    );
};
